export const I18N_PLATFORM_MAP = {
  en_US: 'en',
  zh_CN: 'zh-CN',
  zh_TW: 'zh-TW',
  fr_FR: 'fr',
  ko: 'ko',
  ja: 'ja',
  th: 'th',
  vi: 'vn',
  es: 'es',
  pt: 'pt',
  de: 'de',
  id: 'id',
  ar: 'ar',
  it: 'it',
  pl: 'pl',
  fa: 'fa',
  hi: 'hi',
  ru: 'ru',
}

export const I18N_PAYMENT_CENTER_MAP = {
  en_US: 'en_US',
  zh_CN: 'zh_CN',
  zh_TW: 'zh_TW',
  fr_FR: 'fr_FR',
  ko: 'ko_KR',
  ja: 'ja_JP',
  th: 'th_TH',
  vi: 'vi_VN',
  es: 'es_ES',
  pt: 'pt_PT',
  de: 'de_DE',
  id: 'id_ID',
  ar: 'ar_SA',
  ru: 'ru_RU',
  mn: 'mn_MN',
  km: 'km_KH',
  nl: 'nl_NL',
  it: 'it_IT',
  ms: 'ms_MY',
  pl: 'pl_PL',
  tl: 'tl_PH',
  hi: 'hi_IN',
  fa: 'fa_IR',
}

export const RTL_LANGUAGE_LIST = ['ar', 'fa']
